import { render, staticRenderFns } from "./PageRegisterContentAboveRegisterForm.vue?vue&type=template&id=2c902d64&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports